<div class="grid-detail-wrap border bg-white mb-4">
  <div class="row justify-content-between mb-2">
    <div class="col-md-7">
      <h2>{{ 'ADDITIONAL_FIELDS' | translate }}</h2>
      <app-key-words [keyWords]="this.additionalFields" [isDisabled]="true"></app-key-words>
    </div>

    <div class="col-md-10">
      <div class="category-description">
        <h2>{{ 'DESCRIPTION' | translate }} ({{ 'UA_LANG_SMALL_SHORT' | translate }})</h2>
        <dx-text-area [(value)]="this.service.descriptionUa" class="w-100 mb-3"></dx-text-area>
        <h2>{{ 'DESCRIPTION' | translate }} ({{ 'RU_LANG_SMALL_SHORT' | translate }})</h2>
        <dx-text-area [(value)]="this.service.descriptionRu" class="w-100"></dx-text-area>
      </div>
    </div>

    <div class="col-md-7">
      <h2>{{ 'KEYWORDS' | translate }}</h2>
      <app-key-words [keyWords]="this.keyWords"></app-key-words>
    </div>
  </div>
</div>

<dx-button text="{{ 'SAVE' | translate }}" class="btn" (onClick)="this.save()"></dx-button>
